<template><div><h1 id="zusagentypen" tabindex="-1"><a class="header-anchor" href="#zusagentypen"><span>Zusagentypen</span></a></h1>
<p>Zusagentypen — Definiert die Zusagentypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die Zusagentypen in Zusammenhang mit den Zusagen. Eine Zusage kann zu beliebig vielen Zusagentypen zugeordnet werden, und umgekehrt. Ein Zusagentyp kann als Gruppe definiert werden, in solch einem Fall wird eine Person als Vorstand definiert, die auch die Zusagenfakturierung erhält. Der definierte Betrag wird wenn es eine Gruppe ist als Gesamtbetrag dem Vorstand fakturiert.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Zusagen → Zusagen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Zusage</dt>
<dd>Auswahl der <a class="link" href="ft.refdata.tblzusart.html" title="Zusagen">Zusage</a></dd>
<dt>Typ</dt>
<dd>Zusagentyp</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Zusagentyps</dd>
<dt>Gruppe</dt>
<dd>Zusagentyp als Gruppe definieren. Zusagentypen mit Gruppe können mehrere Personen beinhalten, die Fakturierung erfolgt an den Vorstand.</dd>
<dt>Anzahl</dt>
<dd>Anzahl der aktuell aktiven Zusagetypen; wird online berechnet und angezeigt.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblzusart.html" title="Zusagen">Zusagen</RouteLink></p>
</div></template>


